import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import PropTypes from 'prop-types';

import AuthGradientPanel from './AuthGradientPanel';

const AuthLayout = ({ children }) => {
  const gradientStyle = getConfig().AUTHN_GRADIENT_STYLE;
  const layoutClass = gradientStyle ? 'auth-layout auth-layout--split' : 'auth-layout';

  return (
    <div className={layoutClass}>
      {gradientStyle && <AuthGradientPanel />}
      <div className="auth-layout__card-panel">{children}</div>
    </div>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthLayout;
